export const todayYear = new Date().getFullYear();